import { ESdChangeReason, EWFArrowType, EWFNodeType, IWFDecision } from "@kuika/kuika-cl-model";
import { IWithSDProps, withSD } from "../../../../shared/hoc/screen-design-consumer";
import { IWithContextProp, withContext } from "../../../../shared/hoc/with-context";
import { PureSdComponent } from "../../../../shared/pure-sd";

export interface IWorkFlowForwardPropertiesState {}

export interface IWorkFlowForwardPropertiesProps {
  decisionId?: string | undefined;
}

class WorkFlowForwardProperties extends PureSdComponent<
  IWorkFlowForwardPropertiesProps & IWithSDProps & IWithContextProp,
  IWorkFlowForwardPropertiesState
> {
  constructor(props: IWorkFlowForwardPropertiesProps & IWithSDProps & IWithContextProp) {
    super(props);
  }

  prepareReadOnlyContent = (decisionArrow: IWFDecision) => {
    if (decisionArrow.isDefault) {
      return "This path is set as default. If conditions of other paths not matched, this path will be executed.";
    }
    const condition = decisionArrow.condition?.conditionSet?.conditions[0];
    if (
      condition &&
      condition.field1 &&
      condition.conditionOperator &&
      (condition.conditionOperator.endsWith("pty") || condition.field2)
    ) {
      return (
        <span>
          <div>This path will be executed if</div>
          <span>
            {condition.field1.description.toString()} {condition.conditionOperator?.toString()}{" "}
            {condition.field2 &&
              (condition.field2.description === "" ? condition.field2.fixedValue : condition.field2.description)}{" "}
          </span>
        </span>
      );
    }
    return "This path condition is not set properly. Please check condition on Gateway Node.";
  };

  render() {
    const wf = this.props.sd.selectedWf;
    const decisionArrow = this.props.sd.findNodeRecursively(this.props.decisionId!, EWFNodeType.Arrow, wf!) as
      | IWFDecision
      | undefined;
    return decisionArrow?.arrowType === EWFArrowType.Decision ? (
      <div style={{ margin: "8px" }}>
        <div>{this.prepareReadOnlyContent(decisionArrow)}</div>
      </div>
    ) : (
      <div style={{ margin: "8px" }}>Forward Arrow</div>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    if (changeReason === ESdChangeReason.SaveWorkflow) {
      return true;
    }
    return true;
  };
}

const workFlowForwardProperties = withContext<IWorkFlowForwardPropertiesProps>(
  withSD<IWorkFlowForwardPropertiesProps>(WorkFlowForwardProperties)
);
export { workFlowForwardProperties as WorkFlowForwardProperties };
